module.exports = __webpack_public_path__ + "img/cover-3.003737f4.jpeg";